module.exports = {"510117001":"郫筒街道","510117004":"安德街道","510117005":"红光街道","510117006":"犀浦街道","510117007":"德源街道","510117008":"安靖街道","510117009":"团结街道","510117019":"合作街道","510117020":"西园街道","510117104":"唐昌镇","510117106":"三道堰镇","510117115":"友爱镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510117.json
// module id = 2392
// module chunks = 0